import React from 'react';
import PropTypes from 'prop-types';
import '../css/ExpoDesktop.css';
import Image from './ImageElement';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';
import shuffle from 'shuffle-array';
import ExpoMethods from './ExpoMethods';
/**
 * ExpoDesktop component
 */
class ExpoDesktop extends ExpoMethods{
  static displayName = 'ExpoDesktop';
  static propTypes = {
    className: PropTypes.string,
    tag: PropTypes.string,
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = 'ExpoDesktop';
    this.imageBlock = this.imageBlock.bind(this);
    this.filterByTag = this.filterByTag.bind(this);
    this.projects = this.projects.bind(this);
    this.projectsList = this.projects();
  }


  /**
 * @override
 */
  render() {
    const projects = this.projectsList;

    return (
      <div className={`${this.className} ${this.props.className || ''}`}>
        <div className={`${this.className}__cols`}>
          <div className={`${this.className}__col first`}>
            {projects
              .filter((project, index) => index % 2 === 0)
              .map(this.imageBlock)}
          </div>
          <div className={`${this.className}__col second`}>
            {projects
              .filter((project, index) => index % 2 === 1)
              .map(this.imageBlock)}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ExpoDesktop);
